import React from 'react'
import { useRouteRefresh } from '../../utils/hooks/useRouteRefresh'

/**
 * Composant invisible qui déclenche le rafraîchissement des données utilisateur
 * à chaque changement de route. Doit être rendu à l'intérieur du <BrowserRouter>.
 */
const RouteChangeSync: React.FC = () => {
    useRouteRefresh()
    return null
}

export default RouteChangeSync
